'use client';

import React from 'react';
import * as Styled from './BackgroundLoader.styled';

export const BackgroundLoader: React.FC = () => {
  return <Styled.BackgroundLoader />;
};
